import React from "react";
import axios from "axios";
import Chart from "react-apexcharts";
import ReportsError from './ReportsError';
import { 
    getFromLocalStorage,
    getGraphColours,  
    capitalizationWithExceptions
} from './Utilities';

class ReportsChannelActivityTableBody extends React.Component {
    render() {
        const activities = this.props.activities;

        return (
            <tbody>
                {activities.map(activity => (
                    <tr key={activity.ActivityID + "-" + activity.BrandID}>
                        <td>{capitalizationWithExceptions(activity.ServiceType)}</td>
                        <td>{activity.Activity}</td>
                        <td>{activity.Count}</td>
                    </tr>
                ))}
            </tbody>
        );
    }
}

class ReportsChannelActivityChart extends React.Component {
    render() {
        const activities = [];
        const counts = [];

        this.props.activities.forEach((activity, index) => {
            activities[index] = activity.Activity;
            counts[index] = parseInt(activity.Count, 10);
        });

        const params = {
            options: {
                chart: {
                    id: "report-pie-chart"
                },
                colors: getGraphColours(),
                labels: activities,
                tooltip: {
                    enabled: false
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none'
                        }
                    }
                },
                legend: {
                    onItemHover: {
                        highlightDataSeries: false
                    }
                }
            },
            series: counts
        };

        return (
            <Chart
                options={params.options}
                series={params.series}
                type="pie"
                width="100%"
            />
        );
    }
}

class ReportsChannelActivity extends React.Component {
    constructor(props) {
        super(props);
        this.isFetching = false;

        // Retrieve and parse filters from local storage
        let filters = getFromLocalStorage("report_data");
        if (typeof filters === "string") {
            filters = JSON.parse(filters);
        }

        const brandIDs = this.getBrandIDs(filters?.ChooseBrands);
        let endpoint = "brand/stats/activity";
        if (brandIDs && brandIDs.length > 0) {
            endpoint += "&brandids=" + brandIDs;
        }

        let url = "react/process?endpoint=" + endpoint + "&hourly_cutoff=0&turnoffdebug=1&includeonetime=1";
        if (filters?.ChooseActivities?.Segment?.ID) {
            url += "&segmentid=" + filters.ChooseActivities.Segment.ID;
        }

        this.state = {
            url,
            activities: [],
            isLoading: true,
            error: null,
            "view": props.view || "graph"
        };
    }

    getBrandIDs(brandData) {
        if (!brandData) return "";
        const brands = Object.values(brandData)
            .filter(obj => typeof obj !== "undefined" && obj.ID)
            .map(obj => obj.ID);
        return brands.length > 1 ? brands.join(",") : brands;
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        if (this.isFetching) return;
        this.isFetching = true;

        let url = this.state.url;
        if (this.props.next > 0) {
            url += `&next=${this.props.next}`;
        }

        axios.get(url)
            .then(response => {
                this.isFetching = false;
                this.formatData(response.data);
            })
            .catch(err => {
                this.isFetching = false;
                console.error("Fetch error:", err);
                this.setState({ isLoading: false, error: "Failed to load data" });
            });
    }

    formatData(data) {
        let activities = data.items || [];
        const error = data?.error || null;

        // Limit the number of activities
        activities = activities.slice(0, 25);

        this.setState({ activities, isLoading: false, error: error?.message });
    }

    render() {
        const { activities, isLoading, error } = this.state;
        const currentView = this.props.view; // table or graph

        if (isLoading) {
            return (
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="loading col-md-4">
                        <div className="react-loading big" style={this.props.loaderStyle}></div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            );
        }

        if (!activities.length) {
            return (
                <ReportsError
                    error={error}
                    type="activities"
                    table="false"
                    hash="#ChooseActivities"
                />
            );
        }

        return currentView === "graph" ? this.renderGraph() : this.renderTable();
    }

    renderTable() {
        return (
            <div className="feed-activitylist">
                <table id="basic-datatable" className="table dt-responsive nowrap w-100">
                    <thead>
                        <tr>
                            <th>Service</th>
                            <th>Activity</th>
                            <th>Count</th>
                        </tr>
                    </thead>
                    <ReportsChannelActivityTableBody activities={this.state.activities} />
                </table>
            </div>
        );
    }

    renderGraph() {
        return (
            <div className="chart-activitylist">
                <ReportsChannelActivityChart activities={this.state.activities} />
            </div>
        );
    }
}

export default ReportsChannelActivity;
